module.exports = {"361124100":"河口镇","361124101":"永平镇","361124102":"石塘镇","361124103":"鹅湖镇","361124105":"湖坊镇","361124106":"武夷山镇","361124108":"汪二镇","361124200":"陈坊乡","361124201":"虹桥乡","361124202":"新滩乡","361124203":"葛仙山乡","361124205":"稼轩乡","361124206":"英将乡","361124207":"紫溪乡","361124208":"太源畲族乡","361124209":"天柱山乡","361124210":"篁碧畲族乡","361124407":"铅山县青溪服务中心","361124501":"铅山县国营森林苗圃"}


//////////////////
// WEBPACK FOOTER
// ./src/town/361124.json
// module id = 1343
// module chunks = 0